import PropTypes from 'prop-types';

import Heading from 'shopper/components/Heading';

import ArticlesCarousel from './ArticlesCarousel';

const MediaArticles = ({ className }) => (
  <section className={className}>
    <Heading className="mb-6 text-center" size="size2">
      <Heading as="span" className="text-gradient-highlight" size="size2">
        Promobit
      </Heading>{' '}
      na mídia
    </Heading>
    <ArticlesCarousel />
  </section>
);

MediaArticles.propTypes = {
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

export default MediaArticles;
